import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

export default function CultivateCoinMint() {
  const passes = [
    {
      name: "Farmer Pass",
      image: "/assets/images/farmer.png",
      description: "Manage Growbox Operations."
    },
    {
      name: "Negotiator Pass",
      image: "/assets/images/Negotiator.png",
      description: "Control the Marketplace Deals."
    },
    {
      name: "Operator Pass",
      image: "/assets/images/operator.png",
      description: "Oversee Global Expansion."
    }
  ];

  const mintUrl = "https://launchmynft.io/collections/6AUXuSg2MBwPq5QPYyGqivZjzgn6GZJ3iJ4o5r3wD6ie/hpKs1852314AJH4mGcs7";
  const seoDescription = "Cultivate Coin is a living simulation that connects players, robots, and real-world farming. Secure your exclusive Operator, Negotiator, or Farmer Pass today and help shape the future.";
  const seoImage = "https://selflabs.org/assets/images/cultivatecon.png";

  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Cultivate Coin Pass Mint | SELF Labs</title>
        <meta name="description" content={seoDescription} />
        
        {/* OpenGraph tags */}
        <meta property="og:title" content="Cultivate Coin Pass Mint" />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:image" content={seoImage} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SELF Labs" />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Cultivate Coin Pass Mint" />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={seoImage} />
      </Helmet>

      <div className="max-w-6xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-green-400 to-blue-500 text-transparent bg-clip-text">
            Cultivate Coin Pass Mint
          </h1>
          <h2 className="text-xl md:text-2xl text-gray-300 mb-6">
            Join the Future of Sustainable Agriculture and Gaming
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Cultivate Coin is a living simulation that connects players, robots, and real-world farming. 
            Secure your exclusive Operator, Negotiator, or Farmer Pass today and help shape the future.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7 }}
          className="mb-16 relative"
        >
          <div className="aspect-[16/9] overflow-hidden rounded-2xl 
                        shadow-[0_0_30px_rgba(34,197,94,0.2)]
                        hover:shadow-[0_0_40px_rgba(34,197,94,0.3)]
                        transition-all duration-300">
            <img 
              src="/assets/images/cultivatecon.png"
              alt="Cultivate Coin: The Future of Sustainable Agriculture"
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {passes.map((pass, index) => (
            <motion.div
              key={pass.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="bg-gradient-to-b from-gray-900 to-black rounded-2xl p-6 border border-gray-800 hover:border-green-500/50 transition-all"
            >
              <div className="aspect-square overflow-hidden rounded-xl mb-4">
                <img 
                  src={pass.image} 
                  alt={pass.name}
                  className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300"
                />
              </div>
              <h3 className="text-xl font-bold mb-2 text-green-400">{pass.name}</h3>
              <p className="text-gray-400">{pass.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <motion.a
            href={mintUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-12 py-4 text-lg font-bold text-white bg-gradient-to-r from-green-500 to-blue-500 rounded-full 
                     shadow-[0_0_20px_rgba(34,197,94,0.5)] hover:shadow-[0_0_30px_rgba(34,197,94,0.7)] 
                     transition-all duration-300 transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Mint Now
          </motion.a>
        </div>
      </div>
    </div>
  );
} 